// Ported from Dealtracker src/appframe/tours/session.ts (commit 30ca0cb); the key is Niobe's.
/** The in-progress tour (D8a), kept for the browser tab so a reload can resume it. */
export interface ActiveTour {
  id: string;
  version: number;
  /** 0-based index of the current step. */
  step: number;
  /**
   * 0-based index of the furthest step reached in this run: **Next** fast-forwards up to it,
   * never past it (Back/Next, ticket #150). Missing in a pre-#150 save → `step`.
   */
  furthest: number;
  /** Epoch ms. */
  startedAt: number;
}

export const ACTIVE_TOUR_KEY = 'niobe.tour.active';

export function readActiveTour(): ActiveTour | null {
  try {
    const raw = sessionStorage.getItem(ACTIVE_TOUR_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<ActiveTour>;
    if (typeof v.id !== 'string' || typeof v.version !== 'number'
      || typeof v.step !== 'number' || typeof v.startedAt !== 'number') return null;
    const furthest = typeof v.furthest === 'number' && v.furthest >= v.step ? v.furthest : v.step;
    return { id: v.id, version: v.version, step: v.step, furthest, startedAt: v.startedAt };
  } catch {
    return null;
  }
}

export function writeActiveTour(t: ActiveTour): void {
  try { sessionStorage.setItem(ACTIVE_TOUR_KEY, JSON.stringify(t)); } catch { /* storage blocked */ }
}

export function clearActiveTour(): void {
  try { sessionStorage.removeItem(ACTIVE_TOUR_KEY); } catch { /* storage blocked */ }
}
